import {LeftRail} from './LeftRail';
export default LeftRail;
